import { createTheme } from "@mui/material/styles";

const headingFontFamily = [
  '"Ubuntu"',
  '"Roboto"',
  '"Helvetica"',
  '"Arial"',
  "sans-serif",
].join(", ");

export const COLORS = {
  blue: "#162BA5",
  purple: "#AB16F9",
  lightBlueBg: "#CDD2EC",
  lightBlack: "#383838",
  profileBg: "#F7F7FA",
  textGray: "#707070",
  lightPurple: "#CFD0EA",
};

export const theme = createTheme({
  palette: {
    primary: { main: COLORS.blue },
    secondary: { main: COLORS.purple },
  },
  typography: {
    fontFamily: headingFontFamily,
  },
  components: {
    MuiButton: {
      defaultProps: { disableRipple: true },
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: "bold",
          "&:hover": { backgroundColor: COLORS.blue, color: "white" },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          color: COLORS.lightBlack,
          fontFamily: headingFontFamily,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { backgroundColor: "white" },
      },
    },
  },
});
